export class InventoryResourceMetadata {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "disallowedScopes",
            "baseName": "disallowedScopes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InventoryResourceMetadata.attributeTypeMap;
    }
    constructor() {
    }
}
